import { GetPopularKeywordsQuery } from '@/types/bff/gql-schema';
import { PopularSymptomVo } from '@/types/search';
import { useGetPopularKeywordsQuery } from './search.gql.impl';

const parseGetPopularSymptomsVo = (popularSymptomDto: GetPopularKeywordsQuery | undefined): PopularSymptomVo => {
  const getPopularSymptoms = popularSymptomDto?.getPopularSymptoms ?? [];

  const popularSymptomList = getPopularSymptoms.map((symptom: { name: string; publicId: string }) => {
    if (!symptom) {
      return {
        symptomName: '',
        symptomPublicId: '',
      };
    }
    return {
      symptomName: symptom.name,
      symptomPublicId: symptom.publicId,
    };
  });

  return {
    popularSymptomList,
  };
};

const useGetPopularKeywordsForDiseaseSymptomSearch = () => {
  const { data, isLoading } = useGetPopularKeywordsQuery();

  const { popularSymptomList } = parseGetPopularSymptomsVo(data);

  return {
    popularSymptomList,
    isLoading,
  };
};

export default useGetPopularKeywordsForDiseaseSymptomSearch;
